export const mapBackendToForm = (data) => {
  if (!data) return {};

  const sanitizeData = (obj) => {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = obj[key] === null ? '' : obj[key];
      return acc;
    }, {});
  };

  const cleanData = sanitizeData(data);

  // Normalize vital fields to strings
  cleanData.vital_pr = cleanData.vital_pr === true ? "Yes" : cleanData.vital_pr === false ? "No" : cleanData.vital_pr;
  cleanData.vital_bp = cleanData.vital_bp === true ? "Yes" : cleanData.vital_bp === false ? "No" : cleanData.vital_bp;
  cleanData.vital_o2sat = cleanData.vital_o2sat === true ? "Yes" : cleanData.vital_o2sat === false ? "No" : cleanData.vital_o2sat;

  // Handle date fields - separate date-only and datetime fields
  const dateOnlyFields = ['date'];
  const dateTimeFields = ['checklist_time', 'received_in_ot_at', 'shifted_to_ot_at'];

  dateOnlyFields.forEach(field => {
    if (cleanData[field]) {
      if (/^\d{4}-\d{2}-\d{2}$/.test(cleanData[field])) {
        // already good
      } else {
        cleanData[field] = new Date(cleanData[field]).toISOString().slice(0, 10);
      }
    }
  });

  dateTimeFields.forEach(field => {
    if (cleanData[field]) {
      if (/^\d{4}-\d{2}-\d{2}$/.test(cleanData[field])) {
        cleanData[field] = cleanData[field] + 'T00:00';
      } else {
        cleanData[field] = new Date(cleanData[field]).toISOString().slice(0, 16);
      }
    }
  });

  // Handle bowel_preparation_time
  let bowelTime = '';
  if (cleanData.bowel_preparation_time) {
    const parts = cleanData.bowel_preparation_time.split(':');
    if (parts.length >= 2) {
      bowelTime = `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}`;
    }
  }
  cleanData.bowel_preparation_time = bowelTime;

  return cleanData;
};

export const mapFormToBackend = (formData) => {
  // Directly spread the formData because it maps exactly to the expected DB model
  return { ...formData };
};

export const validatePreOpChecklist = (formData) => {
  const errors = {};
  const requiredFields = [
    { key: 'date',       label: 'Surgery Date'   },
    { key: 'consultant', label: 'Consultant Name' },
    { key: 'room_no',    label: 'Room No.'        },
  ];

  requiredFields.forEach(({ key, label }) => {
    if (!formData[key] || String(formData[key]).trim() === '') {
      errors[key] = `${label} is required`;
    }
  });

  return errors;
};
